module.exports = __webpack_public_path__ + "static/media/animated_image.4a0bdfa1.png";